(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[366],{

/***/ 40366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ab_configurador_estuches_src; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ../node_modules/numeral/numeral.js
var numeral = __webpack_require__(94960);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
// EXTERNAL MODULE: ../node_modules/lodash-es/uniqBy.js + 8 modules
var uniqBy = __webpack_require__(29378);
// EXTERNAL MODULE: ../node_modules/lodash-es/find.js + 1 modules
var find = __webpack_require__(56232);
// EXTERNAL MODULE: ../node_modules/lodash-es/some.js + 1 modules
var some = __webpack_require__(577);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ../node_modules/next-i18next/dist/esm/index.js + 28 modules
var esm = __webpack_require__(62062);
// EXTERNAL MODULE: ../packages/ab-text/src/index.tsx
var src = __webpack_require__(145);
// EXTERNAL MODULE: ../packages/ab-paragraph-text/src/index.tsx
var ab_paragraph_text_src = __webpack_require__(2569);
// EXTERNAL MODULE: ../packages/ab-quantity-picker/src/index.tsx
var ab_quantity_picker_src = __webpack_require__(40322);
// EXTERNAL MODULE: ../packages/ab-personalizacion/src/index.tsx
var ab_personalizacion_src = __webpack_require__(36149);
// EXTERNAL MODULE: ../packages/ab-form-button/src/index.tsx
var ab_form_button_src = __webpack_require__(81402);
// EXTERNAL MODULE: ../packages/ab-context-cart/src/index.tsx + 3 modules
var ab_context_cart_src = __webpack_require__(29359);
// EXTERNAL MODULE: ../packages/ab-context-user/src/index.tsx + 4 modules
var ab_context_user_src = __webpack_require__(38416);
// EXTERNAL MODULE: ../packages/ab-configurador-estuches/src/vino-tile.scss
var vino_tile = __webpack_require__(82495);
;// CONCATENATED MODULE: ../packages/ab-configurador-estuches/src/VinoTile.tsx




var VinoTile = function(param) {
    var product = param.product, onClick = param.onClick, selected = param.selected;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "vino-tile".concat(selected ? " selected" : ""),
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: product === null || product === void 0 ? void 0 : (ref = product.image) === null || ref === void 0 ? void 0 : ref.mediaItemUrl,
                alt: product.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                element: "h4",
                children: product.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                element: "span",
                className: "title",
                children: numeral_default()(product.price).format("1,000.00$")
            })
        ]
    });
};
/* harmony default export */ var src_VinoTile = (VinoTile);

// EXTERNAL MODULE: ../packages/ab-configurador-estuches/src/ab-configurador-estuches.scss
var ab_configurador_estuches = __webpack_require__(16202);
;// CONCATENATED MODULE: ../packages/ab-configurador-estuches/src/index.tsx



















var ConfiguradorEstuches = function(param) {
    var name = param.name, description = param.description, price = param.price, databaseId = param.databaseId, galleryImages = param.galleryImages, configuradorEstuches = param.configuradorEstuches, i18n = param.i18n, stockStatus = param.stockStatus, personalizacion = param.personalizacion, etiquetaSKU = param.etiquetaSKU;
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var ref2 = (0,react.useState)(false), loading = ref2[0], setLoading = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,ab_context_cart_src/* useCartContext */.iQ)(), 2), state = ref3[0], dispatch = ref3[1];
    var addItemToCart = dispatch.addItemToCart;
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,ab_context_user_src/* useUserContext */.SE)(), 2), userState = ref4[0], userDispatch = ref4[1];
    var role = userState.role;
    var ref5 = (0,react.useState)(false), personalizeMessage = ref5[0], setPersonalizeMessage = ref5[1];
    var ref6 = (0,react.useState)(false), personalizeEtiqueta = ref6[0], setPersonalizeEtiqueta = ref6[1];
    var ref7 = (0,react.useState)([]), selectedWines = ref7[0], setSelectedWines = ref7[1];
    var ref8 = (0,react.useState)([]), selectedProductos = ref8[0], setSelectedProductos = ref8[1];
    var ref9 = (0,react.useState)(""), tarjetaText = ref9[0], setTarjetaText = ref9[1];
    var ref10 = (0,react.useState)(""), etiquetaText = ref10[0], setEtiquetaText = ref10[1];
    var ref11 = (0,react.useState)(1), quantity = ref11[0], setQuantity = ref11[1];
    var winesToSelect = new Array(configuradorEstuches.numeroBotellas).fill("");
    var productosToSelect = new Array(configuradorEstuches.numeroProductosDeLaFinca || 0).fill("");
    // console.log(
    //   "ConfiguradorEstuches",
    //   configuradorEstuches,
    //   winesToSelect,
    //   selectedWines,
    //   price,
    //   role
    // );
    var tempPrice = 0;
    var tempPriceToShow = numeral_default()(price).value();
    var customiceLabelPrice = "(+5€)";
    // console.log("estuchePrice", tempPriceToShow);
    selectedWines.map(function(itm) {
        tempPrice += numeral_default()(itm === null || itm === void 0 ? void 0 : itm.price).value();
        tempPriceToShow += numeral_default()(itm === null || itm === void 0 ? void 0 : itm.price).value();
    // console.log("estuchePrice", tempPriceToShow, itm);
    });
    selectedProductos.map(function(itm) {
        tempPrice += numeral_default()(itm === null || itm === void 0 ? void 0 : itm.price).value();
        tempPriceToShow += numeral_default()(itm === null || itm === void 0 ? void 0 : itm.price).value();
    // console.log("estuchePrice", tempPriceToShow, itm);
    });
    var notNullSelected = selectedWines.filter(function(itm) {
        return itm !== null;
    });
    if (personalizeEtiqueta) {
        tempPriceToShow += 5;
        if ((notNullSelected === null || notNullSelected === void 0 ? void 0 : notNullSelected.length) == 1) {
            tempPriceToShow += 1;
        }
        if ((notNullSelected === null || notNullSelected === void 0 ? void 0 : notNullSelected.length) == 2) {
            tempPriceToShow += 2;
        }
        if ((notNullSelected === null || notNullSelected === void 0 ? void 0 : notNullSelected.length) == 3) {
            tempPriceToShow += 3;
        }
    }
    // Tarjeton
    if (personalizeMessage) {
        tempPriceToShow += 1;
    }
    if ((notNullSelected === null || notNullSelected === void 0 ? void 0 : notNullSelected.length) == 1) {
        customiceLabelPrice = "(+6€)";
    }
    if ((notNullSelected === null || notNullSelected === void 0 ? void 0 : notNullSelected.length) == 2) {
        customiceLabelPrice = "(+7€)";
    }
    if ((notNullSelected === null || notNullSelected === void 0 ? void 0 : notNullSelected.length) == 3) {
        customiceLabelPrice = "(+8€)";
    }
    if ((numeral_default()).locales.abadia === undefined) {
        numeral_default().register("locale", "abadia", {
            delimiters: {
                thousands: ".",
                decimal: ","
            },
            abbreviations: {
                thousand: "k",
                million: "mm",
                billion: "b",
                trillion: "t"
            },
            ordinal: function ordinal(number) {
                var b = number % 10;
                return b === 1 || b === 3 ? "er" : b === 2 ? "do" : b === 7 || b === 0 ? "mo" : b === 8 ? "vo" : b === 9 ? "no" : "to";
            },
            currency: {
                symbol: "€"
            }
        });
    }
    numeral_default().locale("abadia");
    var t = (0,esm/* useTranslation */.$G)("common", {
        i18n: i18n
    }).t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "ab-configurador-estuches",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "image",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: galleryImages === null || galleryImages === void 0 ? void 0 : (ref = galleryImages.nodes) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.mediaItemUrl
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "detail",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                                element: "h2",
                                children: name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_paragraph_text_src/* default */.Z, {
                                content: description,
                                singleColumn: true
                            })
                        ]
                    })
                ]
            }),
            winesToSelect.map(function(itm, index) {
                var ref;
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                    className: "wine-row",
                    children: [
                        index == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                            element: "span",
                            className: "title",
                            children: t("title")
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                            element: "h3",
                            children: index == 0 ? t("addBottle") : index == 1 ? t("addSecondBottle") : t("addThirdBottle")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: (ref = (0,uniqBy/* default */.Z)(configuradorEstuches.vinos, "producto.databaseId")) === null || ref === void 0 ? void 0 : ref.map(function(innerItm) {
                                var ref, ref1, ref2;
                                var tempItem = innerItm;
                                var hasPrice = (0,find/* default */.Z)(innerItm === null || innerItm === void 0 ? void 0 : innerItm.producto.metaData, [
                                    "key",
                                    "product_role_based_price_".concat(role), 
                                ]);
                                if (hasPrice) {
                                    tempItem.producto.price = "".concat(hasPrice.value.replace(".", ","), "€");
                                }
                                // console.log(
                                //   "ConfiguradorEstuches - price",
                                //   tempItem.price,
                                //   Numeral(tempItem?.price).value()
                                // );
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(src_VinoTile, {
                                    product: tempItem.producto,
                                    selected: (selectedWines === null || selectedWines === void 0 ? void 0 : (ref = selectedWines[index]) === null || ref === void 0 ? void 0 : ref.databaseId) == (innerItm === null || innerItm === void 0 ? void 0 : (ref1 = innerItm.producto) === null || ref1 === void 0 ? void 0 : ref1.databaseId),
                                    onClick: function() {
                                        var ref, ref1;
                                        var tempSelectedWines = (0,_to_consumable_array/* default */.Z)(selectedWines);
                                        // console.log(
                                        //   "VinoTile - onClick - ",
                                        //   innerItm,
                                        //   itm,
                                        //   selectedWines?.[index]?.databaseId ==
                                        //     innerItm?.producto?.databaseId
                                        // );
                                        if ((selectedWines === null || selectedWines === void 0 ? void 0 : (ref = selectedWines[index]) === null || ref === void 0 ? void 0 : ref.databaseId) == (innerItm === null || innerItm === void 0 ? void 0 : (ref1 = innerItm.producto) === null || ref1 === void 0 ? void 0 : ref1.databaseId)) {
                                            tempSelectedWines[index] = null;
                                        } else {
                                            tempSelectedWines[index] = innerItm === null || innerItm === void 0 ? void 0 : innerItm.producto;
                                        }
                                        setSelectedWines(tempSelectedWines);
                                    }
                                }, innerItm === null || innerItm === void 0 ? void 0 : (ref2 = innerItm.producto) === null || ref2 === void 0 ? void 0 : ref2.databaseId);
                            })
                        })
                    ]
                });
            }),
            productosToSelect.map(function(itm, index) {
                var ref;
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                    className: "wine-row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                            element: "h3",
                            children: index == 0 ? t("addProduct") : t("addAnotherProduct")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: (ref = (0,uniqBy/* default */.Z)(configuradorEstuches.productosDeLaFinca, "producto.databaseId")) === null || ref === void 0 ? void 0 : ref.map(function(innerItm) {
                                var ref, ref1, ref2;
                                var tempItem = innerItm;
                                var hasPrice = (0,find/* default */.Z)(innerItm === null || innerItm === void 0 ? void 0 : innerItm.producto.metaData, [
                                    "key",
                                    "product_role_based_price_".concat(role), 
                                ]);
                                if (hasPrice) {
                                    tempItem.producto.price = "".concat(hasPrice.value.replace(".", ","), "€");
                                }
                                ;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(src_VinoTile, {
                                    product: tempItem.producto,
                                    selected: (selectedProductos === null || selectedProductos === void 0 ? void 0 : (ref = selectedProductos[index]) === null || ref === void 0 ? void 0 : ref.databaseId) == (innerItm === null || innerItm === void 0 ? void 0 : (ref1 = innerItm.producto) === null || ref1 === void 0 ? void 0 : ref1.databaseId),
                                    onClick: function() {
                                        var ref, ref1;
                                        var tempSelectedProductos = (0,_to_consumable_array/* default */.Z)(selectedProductos);
                                        // console.log(
                                        //   "VinoTile - onClick - ",
                                        //   innerItm,
                                        //   itm,
                                        //   selectedWines?.[index]?.databaseId ==
                                        //     innerItm?.producto?.databaseId
                                        // );
                                        if ((selectedProductos === null || selectedProductos === void 0 ? void 0 : (ref = selectedProductos[index]) === null || ref === void 0 ? void 0 : ref.databaseId) == (innerItm === null || innerItm === void 0 ? void 0 : (ref1 = innerItm.producto) === null || ref1 === void 0 ? void 0 : ref1.databaseId)) {
                                            tempSelectedProductos[index] = null;
                                        } else {
                                            tempSelectedProductos[index] = innerItm.producto;
                                        }
                                        setSelectedProductos(tempSelectedProductos);
                                    }
                                }, innerItm === null || innerItm === void 0 ? void 0 : (ref2 = innerItm.producto) === null || ref2 === void 0 ? void 0 : ref2.databaseId);
                            })
                        })
                    ]
                });
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_personalizacion_src/* default */.Z, {
                personalizeEtiqueta: personalizeEtiqueta,
                setPersonalizeEtiqueta: setPersonalizeEtiqueta,
                etiquetaText: etiquetaText,
                setEtiquetaText: setEtiquetaText,
                personalizeMessage: personalizeMessage,
                setPersonalizeMessage: setPersonalizeMessage,
                setTarjetaText: setTarjetaText,
                tarjetaText: tarjetaText,
                isEven: (winesToSelect.length + productosToSelect.length) % 2 == 0,
                i18n: i18n,
                customiceLabelPrice: customiceLabelPrice,
                configuradorEstuches: configuradorEstuches,
                serviceSKU: personalizacion,
                etiquetaSKU: etiquetaSKU,
                isEstuche: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "add-to-cart-section  ".concat((winesToSelect.length + productosToSelect.length) % 2 == 0 ? "even" : "odd"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_quantity_picker_src/* default */.Z, {
                            quantity: quantity,
                            setQuantity: setQuantity,
                            i18n: i18n
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                            className: "title",
                            children: numeral_default()(tempPriceToShow * quantity).format("1,000.00$")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_form_button_src/* default */.Z, {
                            loading: loading,
                            disabled: stockStatus == "OUT_OF_STOCK" || (0,some/* default */.Z)(selectedWines, function(wine) {
                                return !(wine === null || wine === void 0 ? void 0 : wine.sku);
                            }) || selectedWines.length + selectedProductos.length != configuradorEstuches.numeroBotellas + (configuradorEstuches.numeroProductosDeLaFinca || 0),
                            onClick: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                var addons, extraData;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            addons = [];
                                            setLoading(true);
                                            addons.push({
                                                display: "".concat(numeral_default()(tempPrice * quantity).format("1,000.00"), "&euro;"),
                                                name: "Estuche - Price",
                                                price: tempPrice,
                                                value: tempPrice
                                            });
                                            if (tarjetaText) {
                                                addons.push({
                                                    name: "A\xf1adir una tarjeta personalizada",
                                                    price: "1",
                                                    value: tarjetaText
                                                });
                                            }
                                            if (personalizeEtiqueta && etiquetaText) {
                                                addons.push({
                                                    name: "Servicio de personalizacion",
                                                    price: "0",
                                                    value: "Si"
                                                });
                                                addons.push({
                                                    name: "Texto para la etiqueta",
                                                    price: "1",
                                                    value: etiquetaText
                                                });
                                            }
                                            addons.push({
                                                name: "Vinos",
                                                price: "",
                                                value: selectedWines.map(function(itm) {
                                                    return itm === null || itm === void 0 ? void 0 : itm.sku;
                                                }).join()
                                            });
                                            addons.push({
                                                name: "Productos de la Finca",
                                                price: "",
                                                value: selectedProductos.map(function(itm) {
                                                    return itm === null || itm === void 0 ? void 0 : itm.sku;
                                                }).join()
                                            });
                                            extraData = {
                                                addons: addons
                                            };
                                            _ctx.next = 10;
                                            return addItemToCart({
                                                databaseId: databaseId,
                                                price: tempPriceToShow
                                            }, quantity, null, JSON.stringify(extraData));
                                        case 10:
                                            if (!(personalizeEtiqueta && etiquetaText)) {
                                                _ctx.next = 13;
                                                break;
                                            }
                                            _ctx.next = 13;
                                            return addItemToCart(personalizacion, 1, null, null);
                                        case 13:
                                            router.push(t("/cesta"));
                                        case 14:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            })),
                            children: stockStatus == "OUT_OF_STOCK" ? t("no-stock") : t("addToCart")
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var ab_configurador_estuches_src = (ConfiguradorEstuches);


/***/ }),

/***/ 81402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var ook_loading__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27336);
/* harmony import */ var _ab_form_button_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73969);
/* harmony import */ var _ab_form_button_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_ab_form_button_scss__WEBPACK_IMPORTED_MODULE_2__);






var FormButton = function(_param) {
    var loading = _param.loading, children = _param.children, onClick = _param.onClick, disabled = _param.disabled, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "loading",
        "children",
        "onClick",
        "disabled"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        className: "ab-form-button",
        type: "submit",
        onClick: onClick,
        disabled: loading || disabled
    }, rest), {
        children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ook_loading__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            loading: true,
            mini: true
        }) : children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (FormButton);


/***/ }),

/***/ 16202:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 82495:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 73969:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);